import CryptoJS from "crypto-js";
import {Logout} from '../../app/modules/auth'

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  
  if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = process.env.REACT_APP_DEV_API_URL + '/api'
  } else {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL + '/api'
  }

  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }
      const providerCode = localStorage.getItem('providerCode')

      // Add providerCode to query parameters if it exists
      if (providerCode) {
        config.params = {
          ...config.params,
          providerCode: providerCode,
        }
      }
      if (config.data && config.url.includes('clients/getBedrockResponse')) {
        return config // Wrap in a key to match backend expectations
      } else if (
        config.data &&
        config.url.includes('clients') &&
        !config.url.includes('upload-csv') &&
        !config.url.includes('getbedrockresponse')
      ) {
        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(config.data),
          process.env.REACT_APP_ENCRYPTION_KEY
        ).toString()
        config.data = {en: encryptedData} // Wrap in a key to match backend expectations
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      if (
        response.config.url.includes('clients/getOne') &&
        response.config.method === 'get' &&
        response.data.client
      ) {
        const decryptedData = CryptoJS.AES.decrypt(
          response.data.client,
          process.env.REACT_APP_ENCRYPTION_KEY
        ).toString(CryptoJS.enc.Utf8)
        response.data.client = JSON.parse(decryptedData)
      } else if (
        response.config.url.includes('clients/update') &&
        response.config.method === 'put' &&
        response.data.data
      ) {
        const decryptedData = CryptoJS.AES.decrypt(
          response.data.data,
          process.env.REACT_APP_ENCRYPTION_KEY
        ).toString(CryptoJS.enc.Utf8)
        response.data.data = JSON.parse(decryptedData)
      }
      return response
    },
    (error: any) => {
      if (error.response && error.response.status === 401) {
        store.dispatch(Logout)
        window.location.href = '/login'
      }
      return Promise.reject(error)
    }
  )
}
